import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import MasterLanding from '../views/fe/Master.vue'
import HomeView from '../views/fe/HomeView.vue'
import ServiceView from '../views/fe/ServiceView.vue'
import NewsDetailView from '../views/fe/NewsDetail.vue'
import PeraturanView from '../views/fe/PeraturanView.vue'
import AuthLayout from '../components/layouts/AuthLayout.vue'
import RegisterView from '../views/fe/RegisterView.vue'
import LoginView from '../views/fe/LoginView.vue'
import ForgotPasswordView from '../views/fe/ForgotPassword.vue'
import SuccessRegisterView from '../views/fe/SuccessRegisterView.vue'
import PetaSebaranSpklu from '../views/fe/PetaSpklu.vue'
import IUPTLView from '../views/fe/IUPTLView.vue'
import PermohonanDayaView from '../views/fe/PermohonanDayaView.vue'
import SuratKeteranganView from '../views/fe/SuratKeteranganView.vue'
import FaqView from '../views/fe/Faq.vue'
import ValidasiTTe from '../views/fe/ValidasiTTe.vue'
import ValidasiDokumen from '../views/fe/ValidasiDokumen.vue'
import ResetPassword from '../views/fe/ResetPassword.vue'
import NotFoundView from '../views/NotFoundView.vue'
import { useAuthStore } from '@/store/auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: MasterLanding,
    children: [
      {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
          pageTitle: "Beranda",
        },
      },

      {
        path: '/layanan-iuptl',
        name: 'layanan-iuptl',
        component: IUPTLView,
        meta: {
          pageTitle: "Layanan IUPTL",
        }
      },
      {
        path: '/layanan-permohonan-daya',
        name: 'layanan-permohonan-daya',
        component: PermohonanDayaView,
        meta: {
          pageTitle: "Layanan Permohonan Daya",
        }
      },
      {
        path: '/layanan-suket',
        name: 'layanan-suket',
        component: SuratKeteranganView,
        meta: {
          pageTitle: "Layanan Permohonan Suket",
        }
      },
      {
        path: '/sebaran-spklu',
        name: 'sebaran-spklu',
        component: PetaSebaranSpklu,
        meta: {
          pageTitle: "Peta Sebaran SPKLU",
        },
      },
      {
        path: '/news-detail',
        name: 'news-detail',
        component: NewsDetailView,
        meta: {
          pageTitle: "Detail Berita"
        }
      },
      {
        path: '/peraturan',
        name: 'peraturan',
        component: PeraturanView,
        meta: {
          pageTitle: "Peraturan",
        },
      },
      {
        path: '/faqs',
        name: 'faqs',
        component: FaqView,
        meta: {
          pageTitle: "FAQs",
        },
      },
      {
        path: '/account-verfication',
        name: 'account-verfication',
        component: SuccessRegisterView,
        meta: {
          pageTitle: "Verifikasi Akun",
        },
      },
      {
        path: '/validate-tte',
        name: 'validate-tte',
        component: ValidasiTTe,
        meta: {
          pageTitle: "Validasi Tanda Tangan Elektronik",
        },
      },
      {
        path: '/docs-validation',
        name: 'docs-validation',
        component: ValidasiDokumen,
        meta: {
          pageTitle: "Validasi Dokumen Surat Keterangan",
        },
      },


      // Auth Layout
      {
        path: '/auth',
        name: 'auth',
        component: AuthLayout,
        children: [
          {
            path: '/login',
            name: 'login',
            component: LoginView,
            meta: {
              pageTitle: "Login",
            },
          },
          {
            path: '/register',
            name: 'register',
            component: RegisterView,
            meta: {
              pageTitle: "Register",
            },
          },
          {
            path: '/forgot-password',
            name: 'forgot-password',
            component: ForgotPasswordView,
            meta: {
              pageTitle: "Lupa Password",
            },
          },
          {
            path: '/reset-password',
            name: 'reset-password',
            component: ResetPassword,
            meta: {
              pageTitle: "Reset Password",
            },
          },

          // {
          //   path : '/forgot-password',
          //   name : 'forgot-password',
          //   component : () => import('../views/auth/ForgotPassword.vue')
          // },
          // {
          //   path : '/reset-password',
          //   name : 'reset-password',
          //   component : () => import('../views/auth/ResetPassword.vue')
          // },
        ]
      }
    ],
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },

  // handle undefined routes
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component : NotFoundView,
    meta: {
      pageTitle: "404 Not Found",
    },
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
});



router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  // const configStore = useConfigStore();


  // current page view title
  document.title = `${to.meta.pageTitle} - ${process.env.VUE_APP_TITLE}`;

  // console.log("router.beforeEach");


  // verify auth token before each page change
  // await authStore.verifyAuth();

  // wait for the auth token verification process




  // before page access check if page requires authentication
  if (to.meta.middleware == "auth") {
    if (authStore.isAuthenticated) {
      next();
    } else {
      next({ name: "sign-in" });
    }
  } else {
    next();
  }

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});

export default router
